export const isInIframe = () => {
  try {
    if (window.self !== window.top) return true; // normal iframe
  } catch (e) {
    return true; // cross-origin iframe
  }

  if (window.frameElement) return true; // hosted in iframe element
  if (document.referrer && document.referrer !== window.location.href)
    return true; // embedded referrer

  return false; // probably top-level
};
